import { useState } from "react";
import {
  Card,
  Typography,
  TextField,
  Box,
  Button,
  Input,
  useMediaQuery,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import MyTable from "../../components/Schedule/MyTable";
import InventoryTable from "./InventoryTable";
import PaginationComponent from "../../components/Pagination/Pagination";
import FormCard from "./FormCard";

const AddLocation = () => {
  const [selectedType, setSelectedType] = useState("appartus");
  const isMobile = useMediaQuery("(max-width: 800px)");
  const [rows, setRows] = useState([
    {
      id: 1,
      "S. No.": 1,
      "Location Title": "Station 1",
      "Location Descrtiption":
        "In publishing and graphic design, Lorem ipsum is a placeholder text commonly used ",
      "Parent Location": "Parent Location 1 ",
    },
    {
      id: 2,
      "S. No.": 2,
      "Location Title": "Station 2",
      "Location Descrtiption":
        "In publishing and graphic design, Lorem ipsum is a placeholder text commonly used",
      "Parent Location": "Parent Location 2",
    },
    {
      id: 3,
      "S. No.": 3,
      "Location Title": "Station 3",
      "Location Descrtiption":
        "In publishing and graphic design, Lorem ipsum is a placeholder text commonly used",
      "Parent Location": "Parent Location 3",
    },
  ]);
  const [fileName, setFileName] = useState("No file chosen");

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFileName(file.name);
    } else {
      setFileName("No file chosen");
    }
  };

  const selectOptions = {
    "Parent Location": [
      { value: "location1", label: "Location 1" },
      { value: "location2", label: "Location 2" },
      { value: "location3", label: "Location 3" },
    ],
  };

  let columns = [
    {
      field: "S. No.",
      headerName: "S. No.",
      sortable: false,
      flex: 1,
      minWidth: 50,
      filterable: false,
    },
    {
      field: "Location Title",
      headerName: "Location Title",
      sortable: false,
      flex: 1,
      minWidth: 250,
      filterable: false,
    },
    {
      field: "Location Descrtiption",
      headerName: "Location Descrtiption",
      sortable: false,
      flex: 1,
      minWidth: 300,
      filterable: false,
    },
    {
      field: "Parent Location",
      headerName: "Parent Location",
      sortable: false,
      flex: 1,
      minWidth: 250,
      filterable: false,
    },
    {
      field: "Actions",
      headerName: "Actions",
      sortable: false,
      flex: 1,
      minWidth: 200,
      filterable: false,
      renderCell: (params) => (
        <Box sx={{ display: "flex", gap: 1 }}>
          <img src="/images/edit.svg"></img>
          <img src="/images/plus.svg"></img>
          <img src="/images/eye.svg"></img>
          <img src="/images/delete.svg"></img>
        </Box>
      ),
    },
  ];

  return (
    <>
      <FormCard
        title={<h5>Add Location</h5>}
        fields={[
          { label: "Parent Location", type: "select" },
          { label: "Title", type: "text", placeholder: "Title of Location" },
          { label: "Type", type: "radio" },
          {
            label: "Description",
            type: "text",
            placeholder: "Description of location",
          },
          { label: "Image", type: "file" },
        ]}
        selectOptions={selectOptions}
        onFileChange={handleFileChange}
        fileName={fileName}
        buttonText="Add Location"
        radioOptions={[
          { value: "appartus", label: "Apparatus" },
          { value: "fixed", label: "Fixed" },
        ]}
        selectedType={selectedType}
        setSelectedType={setSelectedType}
      />

      <Card className="shadow p-3 " style={{ marginTop: "1rem" }}>
        <h5>
          Added Location
        </h5>
        <Box
          sx={{
            width: {
              xs: "100%",
              md: "50%",
            },
          }}
          border={1}
          borderColor="#CCCCCC"
          borderRadius={2}
          p={1}
          marginY={3}
        >
          <TextField
            variant="standard"
            placeholder="Search by keyword"
            style={{ width: "100%", border: "none" }}
            InputProps={{
              endAdornment: <SearchIcon fontSize="small" />,
            }}
            InputLabelProps={{ shrink: true }}
            sx={{
              "& .MuiInputBase-root::before": {
                borderBottom: "none",
              },
              "& .MuiInputBase-root::after": {
                borderBottom: "none",
              },
              "& .MuiInputBase-root:hover:not(.Mui-disabled)::before": {
                borderBottom: "none",
              },
            }}
          />
        </Box>
        {isMobile ? (
          <InventoryTable rows={rows || {}} columns={columns} heading={1} />
        ) : (
          <MyTable
            rows={rows || []}
            columns={columns}
            checkboxSelection={false}
            // loading={tableLoading}
            hideFooter={true}
            className="mt-4"
          />
        )}
      </Card>
      <div className="mt-4 d-flex justify-content-between">
        <Typography>Showing 1-10 from 3 data</Typography>
        <PaginationComponent results={rows || []} />
      </div>
    </>
  );
};

export default AddLocation;
